<template>
  <div class="page-blog-detail">
  <main>
      <section class="border-b border-gray-100 bg-gray-50">
        <div class="mx-auto max-w-4xl px-4 py-10 lg:px-0">
          <div class="space-y-3">
            <div class="flex flex-wrap items-center gap-2 text-xs text-muted">
              <span class="rounded-full bg-white px-3 py-1 font-semibold text-brand shadow-card ring-1 ring-gray-100">Venues</span>
              <span>6 min read</span>
              <span class="h-1 w-1 rounded-full bg-gray-300"></span>
              <span>by Invi8 Editors</span>
            </div>
            <h1 class="text-3xl font-semibold leading-tight text-ink sm:text-4xl">10 sunset ceremony layouts guests actually love</h1>
            <p class="text-lg text-muted">Design-forward aisle ideas that photograph beautifully—without blowing the budget.</p>
            <img class="mt-6 h-80 w-full rounded-3xl object-cover" src="https://dummyimage.com/1200x700/fff6e8/1f2937" alt="Sunset ceremony">
          </div>
        </div>
      </section>

      <article class="mx-auto max-w-4xl px-4 py-10 lg:px-0">
        <div class="prose prose-lg max-w-none text-ink prose-headings:text-ink prose-p:text-muted prose-a:text-brand prose-strong:text-ink">
          <p>Golden hour ceremonies feel effortless when your layout matches the light. Here’s how to build a clean, modern setup your photographer will love.</p>
          <h2>1. Lead with the view</h2>
          <p>Position the aisle so guests face the sunset without squinting. Add low florals or candles instead of tall arches to keep sightlines clear.</p>
          <h2>2. Keep seats minimal</h2>
          <p>Opt for clean chair lines—no bows, no chair covers. Wooden or acrylic chairs keep the frame airy and timeless.</p>
          <h2>3. Use one color anchor</h2>
          <p>Choose a single accent shade (amber, blush, or moss) and keep everything else neutral. It photographs like an editorial spread.</p>
          <h2>4. Frame the aisle with light</h2>
          <p>Lanterns or hidden LEDs down the aisle glow as the sun sets. If wind is a factor, use flameless candles in hurricanes.</p>
          <blockquote>“The best ceremonies are simple. Let the light do the heavy lifting.” — Jess, Photographer on Invi8</blockquote>
          <h2>5. Add a soft finale</h2>
          <p>After the kiss, funnel guests toward cocktails with string lights or a champagne tower nearby. It keeps energy high and photos candid.</p>
          <p>Ready to find a venue that does sunset right? Browse our curated picks with real pricing.</p>
        </div>

        <div class="mt-10 grid gap-6 rounded-3xl bg-gray-50 p-6 ring-1 ring-gray-100 sm:grid-cols-2">
          <div>
            <p class="text-sm font-semibold text-ink">Vendors featured</p>
            <ul class="mt-2 space-y-2 text-sm text-muted">
              <li>• Lumen Glasshouse Venue (Napa)</li>
              <li>• Rove Photo Studio (LA)</li>
              <li>• Arcadia Decor Co. (Seattle)</li>
            </ul>
          </div>
          <div class="rounded-2xl bg-white p-4 shadow-card ring-1 ring-gray-100">
            <p class="text-sm font-semibold text-ink">Get a shortlist</p>
            <p class="text-sm text-muted">Share your date and vibe. We’ll send 5 options tonight.</p>
            <div class="mt-3 flex flex-col gap-3 sm:flex-row">
              <input class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="Email address" />
              <button class="rounded-2xl bg-brand px-4 py-3 text-sm font-semibold text-white transition hover:bg-brandDark">Send</button>
            </div>
          </div>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
export default {
  name: 'BlogDetailView'
}
</script>
